import { TableDataWithImage } from '@spo/logic';
import {
  SpoArchitectureNaturesTableResponseItem,
  SpoPersonalOfferTableResponseDataItem,
} from '@spo/types';
import { createColumnHelper } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArchiRowActions } from '../../components/archiNatureTable/archiRowActions';
import { ArchiRowEnable } from '../../components/archiNatureTable/archiRowEnable';
import { DateCellTable } from '../../components/table/dateCellTable';
import { LabelCellTable } from '../../components/table/labelCellTable';
import { RowActions } from '../../components/table/rowActions';

export const columnsMassEdit = () => {
  const columnHelper =
    createColumnHelper<SpoPersonalOfferTableResponseDataItem>();
  const columns = [
    columnHelper.accessor('id', {
      header: 'Code',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('descriptionEn', {
      header: 'Label',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('productNatureLabel', {
      header: 'Product Nature',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('userSegmentationLabel', {
      header: 'User Segmentation',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('startDate', {
      header: 'Start date',
      cell: (info) => (
        <DateCellTable date={info.getValue()} extremumDate="start" />
      ),
    }),
    columnHelper.accessor('endDate', {
      header: 'End date',
      cell: (info) => format(new Date(info.getValue()), 'dd/MM/yyyy'),
    }),
    columnHelper.accessor('productManagerLabel', {
      header: 'Product Manager',
      cell: (info) => info.getValue(),
    }),
  ];
  return columns;
};

export const columnsSuperModel = () => {
  const columnHelper = createColumnHelper<TableDataWithImage>();

  const columns = [
    columnHelper.accessor('id', {
      header: 'Code',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('descriptionEn', {
      header: 'Label',
      cell: ({ row }) => (
        <LabelCellTable
          picture={row.original.imageURL}
          label={row.original.descriptionEn}
        />
      ),
    }),
    columnHelper.accessor('productNatureLabel', {
      header: 'Product Nature',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('technicityLevel', {
      header: 'Technicity',
      cell: (info) => (info.getValue() === null ? 'NO' : info.getValue()),
    }),
    columnHelper.accessor('startDate', {
      header: 'Start date',
      cell: (info) => (
        <DateCellTable date={info.getValue()} extremumDate="start" />
      ),
    }),
    columnHelper.accessor('endDate', {
      header: 'End date',
      cell: (info) => format(new Date(info.getValue()), 'dd/MM/yyyy'),
    }),
    columnHelper.accessor('productManagerLabel', {
      header: 'Product Manager',
      cell: (info) => info.getValue(),
    }),
    //TODO: use proper accessor
    columnHelper.accessor('brandId', {
      header: () => <span></span>,
      cell: ({ row }) => (
        <RowActions
          smId={row.original.id}
          startDate={row.original.startDate}
          endDate={row.original.endDate}
        />
      ),
    }),
  ];

  return columns;
};

export const columnsArchiNatures = (
  setDrawerNatureId: (natureId: string) => void,
  removeDeletedNature: (natureId: string) => void,
  updateArchitectureData: (productNatureId: number, isEnabled: boolean) => void,
) => {
  const columnHelper =
    createColumnHelper<SpoArchitectureNaturesTableResponseItem>();

  const columns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('label', {
      header: 'Label',
      cell: (info) => {
        const label = info.getValue();
        return label ?? <span>-</span>;
      },
    }),
    columnHelper.accessor('ddfsStatus', {
      header: 'DDFS Status',
      cell: (info) => {
        const status = info.getValue();
        return (
          <span className={`ddfs-status ${status ? 'active' : 'inactive'}`}>
            {status}
          </span>
        );
      },
    }),
    columnHelper.accessor('enabled', {
      header: 'Disable/Enable',
      cell: (info) => {
        const toggleStatus = info.getValue();
        return (
          <ArchiRowEnable
            toggleStatus={toggleStatus}
            productNatureId={info.row.original.id}
            updateArchitectureData={updateArchitectureData}
          />
        );
      },
    }),
    columnHelper.accessor('id', {
      header: () => <span>Action</span>,
      cell: ({ row }) => {
        const natureId = row.original.id;
        const enabled = row.original.enabled;
        const deletable = row.original.deletable;
        return (
          <ArchiRowActions
            natureId={natureId}
            enabled={enabled}
            deletable={deletable}
            setDrawerNatureId={setDrawerNatureId}
            removeDeletedNature={removeDeletedNature}
          />
        );
      },
    }),
  ];

  return columns;
};
